import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/views/Home.vue'
import Lms from '@/views/Lms.vue'
import Entry from '@/views/Entry.vue'
import GzhMenuManager from '@/views/gzhMenuManager.vue'
import GzhManager from '@/views/gzhManager.vue'
import GzhMenuEdit from '@/views/gzhMenuEdit.vue'

import { Api } from '@/service/api'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/lms',
    name: 'Lms',
    component: Lms,
    meta: {
      title: '订单确认',
    }
  },
  {
    path: '/gzh-menu-edit',
    name: 'gzh-menu-edit',
    component: GzhMenuEdit,
    meta: {
      title: '编辑菜单',
    }
  },
  {
    path: '/gzh_entry',
    name: 'Entry',
    component: Entry,
    meta: {
      title: '公众号列表',
    }
  },
  {
    path: '/gzh_manager',
    name: 'gzh_manager',
    component: GzhManager,
    meta: {
      title: '公众号管理',
    }
  },
  {
    path: '/gzh_menu_manager',
    name: 'gzh_menu_manager',
    component: GzhMenuManager,
    meta: {
      title: '菜单管理',
    }
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      type: 'public'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  console.info(to.fullPath)
  console.info('beforeEach')
  const type = to.meta.type
  // 判断该路由是否需要登录权限
  if (type === 'public') {
    next()
  } else {
    // 登录检查
    Api.isLogin()
      .then((login) => {
        if (login) {
          next()
        } else {
          Api.autoLogin(to.fullPath)
          // .then((result) => {
          //   if (result) {
          //     next({ path: result, replace: true })
          //   }
          // })
        }
      })
  }
})

export default router
